import { OrderDetails } from './OrderDetails'
import { GoodsHoldersTabs } from '../../goodsholders/GoodsHoldersTabs'
import { Icon, Text } from '@nike/eds'
import { BackButton } from '../../../common/components/backbutton/BackButton'
import { PageLink } from '../../../common/components/links/Links'
import { ShipmentStatusBar } from './ShipmentStatusBar'
import { ApolloResult } from '../../../common/ApolloResult'
import { ShipmentMilestones } from './milestones/ShipmentMilestones'
import { ShipmentStatusCode } from './ShipmentStatusCode'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { TrackAndTraceExceptions } from '../../track-and-trace/TrackAndTraceExceptions'
import { useGetShipmentLazyQuery } from '../../../generated/graphql'
import { ShipmentTrackAndTraceEvents } from '../../track-and-trace/ShipmentTrackAndTraceEvents'
import { ShipmentDetailsTabs } from './ShipmentDetailsTabs'
import useRoleContext from '../../../common/hooks/useRoleContext'

export function ShipmentPage() {
  let { packlistNumber } = useParams()

  const hasCustomerDetailsAccess = useRoleContext().hasCustomerDetailsAccess()

  const [fetchShipment, queryResult] = useGetShipmentLazyQuery({
    variables: { packlistNumber },
    context: { page: 'shipments' },
  })
  const shipment = queryResult?.data?.getShipment

  //Use effect to force refresh when the page is revisited
  useEffect(() => {
    fetchShipment()
  }, [fetchShipment, packlistNumber])

  return (
    <div className="column-layout--row-gap-24">
      <title className="title">
        <BackButton />
        <Text font="display-4" as="h1">
          Packlist {packlistNumber}
        </Text>
        {shipment && <ShipmentStatusCode status={shipment.calculatedShipmentStatusCode} />}
      </title>
      <ApolloResult {...queryResult}>
        {shipment ? (
          <>
            <ShipmentStatusBar shipment={shipment} />
            {shipment.ttExceptions?.length && (
              <TrackAndTraceExceptions ttExceptions={shipment.ttExceptions} />
            )}
            <OrderDetails shipment={shipment} />
            <ShipmentDetailsTabs shipment={shipment} />
            <ShipmentMilestones shipment={shipment} />
          </>
        ) : null}
      </ApolloResult>
      <ShipmentTrackAndTraceEvents packlistNumber={packlistNumber} />
      <GoodsHoldersTabs
        packlistNumber={packlistNumber}
        shippingPointCode={shipment?.shippingPointCode}
      />
      {hasCustomerDetailsAccess && (
        <PageLink pathPrefix="/events/" id={packlistNumber}>
          <Icon name="Show" />
        </PageLink>
      )}
    </div>
  )
}
